<template>
  <div>
    <MainSpecialized />

    <router-view></router-view>
  </div>
</template>

<script>
import MainSpecialized from "./components/MainSpecialized.vue";

export default {
  components: {
    MainSpecialized,
  },
};
</script>
